import { createContext, useState } from 'react';
import { PropTypes } from 'prop-types';

export const CarouselContext = createContext();

const TeamContextProvider = ({ children }) => {
  const [activeSlide, setActiveSlide] = useState(0);
  const [totalSlide, setTotalSlide] = useState(2);

  const next = () => {
    setActiveSlide((prev) => {
      if (prev === totalSlide - 1) {
        return 0;
      } else {
        return prev + 1;
      }
    });
  };

  const prev = () => {
    setActiveSlide((prev) => {
      if (prev === 0) {
        return totalSlide - 1;
      } else {
        return prev - 1;
      }
    });
  };

  return (
    <CarouselContext.Provider
      value={{ activeSlide, prev, next, setTotalSlide, setActiveSlide, totalSlide }}
    >
      {children}
    </CarouselContext.Provider>
  );
};

TeamContextProvider.propTypes = {
  children: PropTypes.node.isRequired,
};

export default TeamContextProvider;
